module.exports = __webpack_public_path__ + "img/适老化改造.b5d0b320.png";